import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Helpers } from '../helpers';
import { ScriptLoaderService } from '../_services/script-loader/script-loader.service';

declare let mApp: any;
declare let mUtil: any;
declare let mLayout: any;
@Component({
    selector: ".m-grid.m-grid--hor.m-grid--root.m-page",
    templateUrl: "./core.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class CoreComponent implements OnInit {


    constructor(private _script: ScriptLoaderService, private _router: Router) {

    }

    ngOnInit() {
        this._script.loadScripts('body', ['assets/vendors/base/vendors.bundle.js', 'assets/demo/demo2/base/scripts.bundle.js'], true)
            .then(result => {
                Helpers.setLoading(false);
                // optional js to be loaded once
                this._script.loadScripts('head', ['assets/vendors/custom/fullcalendar/fullcalendar.bundle.js']);
            });
        this._router.events.subscribe((route) => {
            if (route instanceof NavigationStart) {
                (<any>mLayout).closeMobileAsideMenuOffcanvas();
                (<any>mLayout).closeMobileHorMenuOffcanvas();
                (<any>mApp).scrollTop();
                Helpers.setLoading(true);
                // hide visible popover
                (<any>$('[data-toggle="m-popover"]')).popover('hide');
            }
            if (route instanceof NavigationEnd) {
                // init required js
                (<any>mApp).init();
                (<any>mUtil).init();
                Helpers.setLoading(false);
                // content m-wrapper animation
                let animation = 'm-animate-fade-in-up';
                $('.m-wrapper').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(e) {
                    $('.m-wrapper').removeClass(animation);
                }).removeClass(animation).addClass(animation);
                // collapsible filter panels on mobile / tablet
                setTimeout(() => this.setupMobileFilters(), 300);
            }
        });
    }

    /**
     * Mobile / tablet only (< 992px): adds a "Filters" toggle button to each portlet head
     * and hides the filter panel until it is tapped. Desktop is untouched.
     * Only `.filter-panel` blocks (and rows of `.filter-field`) are collapsed, so real
     * create / edit forms are never hidden.
     */
    private setupMobileFilters(): void {
        if (window.innerWidth >= 992) {
            return;
        }
        $('.m-portlet').each(function() {
            const $portlet = $(this);
            const $head = $portlet.find('> .m-portlet__head').first();
            const $body = $portlet.find('> .m-portlet__body').first();
            if (!$head.length || !$body.length) {
                return;
            }

            const $filterEls = $body.children().filter(function() {
                const $el = $(this);
                if ($el.is('.filter-panel--static')) {
                    return false;
                }
                if ($el.is('.filter-panel')) {
                    return true;
                }
                return $el.is('.row') && $el.find('.filter-field').length > 0;
            });
            if (!$filterEls.length) {
                return;
            }
            $filterEls.addClass('mobile-filter-element');

            if ($head.find('.mobile-filter-toggle-btn').length) {
                return;
            }
            let $tools = $head.find('> .m-portlet__head-tools');
            if (!$tools.length) {
                $tools = $('<div class="m-portlet__head-tools"></div>');
                $head.append($tools);
            }

            const $btn = $('<button class="mobile-filter-toggle-btn" type="button">' +
                '<i class="la la-sliders"></i> Filters <i class="la la-angle-down mobile-filter-chevron"></i>' +
                '</button>');
            $btn.on('click', function(e) {
                e.preventDefault();
                $portlet.toggleClass('mobile-filters-expanded');
            });
            $tools.prepend($btn);
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/core/core.component.ts